/* ============================================================
   EPICLABS® — Smart Native Wishlist  v1.0
   - LocalStorage backed (no app required)
   - Heart toggle buttons via [data-epic-wish] (value = product handle or id)
   - Live count via [data-epic-wish-count]
   - Cross-tab sync via storage event
   - Customizes <epic-wishlist-grid> custom element rendering
   ============================================================ */
(function(){
  if (window.__epicWish) return;
  window.__epicWish = true;

  var KEY = 'epicWishlistV1';

  function read(){
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
    catch(e){ return []; }
  }
  function write(arr){
    try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch(e){}
    broadcast(arr);
  }
  function has(id){ return read().indexOf(String(id)) !== -1; }
  function toggle(id){
    id = String(id);
    var arr = read(), i = arr.indexOf(id);
    if (i === -1) arr.unshift(id);
    else arr.splice(i, 1);
    write(arr);
    return i === -1; // true if added
  }

  function broadcast(arr){
    document.dispatchEvent(new CustomEvent('epic:wishlist:update', { detail: { items: arr } }));
    syncAllButtons();
    syncCounts(arr.length);
    renderGrids();
  }

  function syncAllButtons(){
    document.querySelectorAll('[data-epic-wish]').forEach(function(btn){
      var id = btn.getAttribute('data-epic-wish');
      var active = has(id);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('aria-label', active ? 'Quitar de favoritos' : 'Añadir a favoritos');
    });
  }
  function syncCounts(n){
    document.querySelectorAll('[data-epic-wish-count]').forEach(function(el){
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
    });
  }

  function toast(msg){
    var t = document.createElement('div');
    t.className = 'epic-wish-toast';
    t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function(){ t.classList.add('is-show'); });
    setTimeout(function(){ t.classList.remove('is-show'); setTimeout(function(){ t.remove(); }, 280); }, 1800);
  }

  /* ── Render: any element with data-epic-wish-grid renders product cards via Shopify product fetch ── */
  function renderGrids(){
    document.querySelectorAll('[data-epic-wish-grid]').forEach(function(grid){
      var items = read();
      if (!items.length){
        grid.innerHTML = '<div class="epic-wish-empty">' +
          '<svg width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
          '<h3>Aún no tienes favoritos</h3>' +
          '<p>Guarda los productos que te interesen tocando el corazón. Tus favoritos viajan contigo entre sesiones.</p>' +
          '<a class="epic-wish-empty__btn" href="/collections/all">Explorar productos</a>' +
          '</div>';
        return;
      }
      grid.innerHTML = '<div class="epic-wish-grid">' + items.map(function(handle){
        return '<a class="epic-wish-card" href="/products/' + encodeURIComponent(handle) + '" data-epic-wish-card="' + handle + '">' +
                 '<div class="epic-wish-card__img" data-img-slot></div>' +
                 '<div class="epic-wish-card__body">' +
                   '<h4 class="epic-wish-card__title" data-title-slot>' + handle.replace(/-/g,' ') + '</h4>' +
                   '<p class="epic-wish-card__price" data-price-slot></p>' +
                 '</div>' +
                 '<button type="button" class="epic-wish-card__remove" data-epic-wish="' + handle + '" aria-label="Quitar de favoritos">' +
                   '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
                 '</button>' +
               '</a>';
      }).join('') + '</div>';

      /* Hydrate each card via /products/{handle}.js (low payload). */
      grid.querySelectorAll('[data-epic-wish-card]').forEach(function(card){
        var handle = card.getAttribute('data-epic-wish-card');
        fetch('/products/' + handle + '.js')
          .then(function(r){ if(!r.ok) throw new Error('404'); return r.json(); })
          .then(function(p){
            var img = card.querySelector('[data-img-slot]');
            if (p.featured_image) img.innerHTML = '<img loading="lazy" src="' + p.featured_image + '" alt="' + p.title + '">';
            card.querySelector('[data-title-slot]').textContent = p.title;
            card.querySelector('[data-price-slot]').textContent = (p.price/100).toLocaleString('es-MX', { style:'currency', currency:'MXN' });
          })
          .catch(function(){ /* dejar fallback */ });
      });
    });
  }

  /* ── Delegated click handler ── */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-epic-wish]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var id = btn.getAttribute('data-epic-wish');
    if (!id) return;
    var added = toggle(id);
    btn.classList.add('is-pulse');
    setTimeout(function(){ btn.classList.remove('is-pulse'); }, 360);
    toast(added ? 'Añadido a favoritos' : 'Quitado de favoritos');
  }, true);

  /* ── Cross-tab sync ── */
  window.addEventListener('storage', function(e){ if (e.key === KEY) broadcast(read()); });

  /* ── Init ── */
  function init(){ syncAllButtons(); syncCounts(read().length); renderGrids(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);

  /* Expose minimal API */
  window.EpicWishlist = { read: read, has: has, toggle: toggle, count: function(){ return read().length; } };
})();
